import Service from './Service';

/**
 * Class represents the API for Eurotax database
 * @extends Service
 */
export class EurotaxService extends Service {
    /**
     *  Gépjármű modelleket ad vissza gyártó, járműkategória és gyártási év alapján
     *
     * @param maker gyártó eurotax beli kódja
     * @param category járműkategória eurotax beli kódja
     * @param productYear gyártási év
     * @returns AxiosPromise
     */
    vehicleModelsByMaker(maker, category, productYear) {
        return this.get(`/vehicle-models-by-maker/${maker}?`, { category, productYear });
    }

    /**
     *
     * @param maker
     * @param category
     * @param productYear
     * @param gfb
     * @returns {*}
     */
    vehicleModelGroupsByMaker(maker, category, productYear, gfb = 0) {
        return this.get(`/vehicle-model-groups-by-maker/${maker}?`, { category, productYear, gfb });
    }

    vehiclesByModelGroup(modelGroup, category, productYear) {
        return this.get(`/vehicles-by-model-group/${modelGroup}?`, { category, productYear });
    }

    vehiclesByModelGroupWithExtras(modelGroup, category, productYear) {
        return this.get(`/vehicles-by-model-group-with-extras/${modelGroup}?`, { category, productYear });
    }

    vehicleByEurotaxCode(eurotaxCode) {
        return this.get(`/vehicle-by-eurotax-code/${eurotaxCode}`);
    }

    eurotaxVersion() {
        return this.get('/eurotax-version');
    }

    vehicleExtras(eurotaxCode, category) {
        return this.get(`/vehicle-extras/${eurotaxCode}?`, { category });
    }

    vehicleMakerByCategory(vehicleType) {
        return this.get(`/vehicle-makers-by-category/${vehicleType}`);
    }
}

export const eurotaxService = new EurotaxService('/eurotax');
